import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const TaskFlowLayout = ({ children }) => (
  <main className="container pad-1-tb">
    <div data-testid="task-flow-wrapper">
      {children}
    </div>
  </main>
);

TaskFlowLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TaskFlowLayout;
